import { login } from 'api/layer';
import AlertModal from "components/alertModal/alertModal";
import AddressEncoding from "containers/address-encoding/address-encoding";
import Error from "containers/error/error";
import Home from "containers/home/home";
import Resources from "containers/releases/releases";
import {
  AppContext,
  appContextReducer,
  appInitialState,
} from "helpers/context";
import { MyProvider } from "helpers/map";
import MainLayout from "main-layout";
import { useEffect, useReducer, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import SnackBar from "components/snackBar/snackBar";

function App() {
  const location = useLocation();

  const [isShow, setIsShow] = useState(false);

  const [, forceUpdate] = useState(0);

  useEffect(() => {
    if (!(window as any).systemLoading) {
      const timer = setInterval(() => {
        if ((window as any).systemLoading) {
          forceUpdate((n) => n + 1);
          clearInterval(timer);
        }
      }, 100);
      return () => clearInterval(timer);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    if (code) {
      sessionStorage.setItem('code', code);
      if (params.get('code')) {
        params.delete('code');
        let newUrl = params.toString();
        window.history.replaceState({}, '', `${location.pathname + (newUrl ? '?' + newUrl : '')}`);
      }
      login({ code }).then((res: any) => {
        setIsShow(true)
          if (res.code === 200) {
          sessionStorage.setItem('token', res.data.token);
          }
      }).catch(() => {
        setIsShow(true)
        })
    } else {
      setIsShow(true)
    }
  }, [location.search]);

  const appContextValue = useReducer(appContextReducer, appInitialState);

  return (<>
    {
      !(window as any).systemLoading &&
      (<div className="w-full h-full flex justify-center items-center absolute z-[9999] bg-white">
          <div className="next-loading-fusion-reactor">
            <span className="next-loading-dot"></span>
            <span className="next-loading-dot"></span>
            <span className="next-loading-dot"></span>
            <span className="next-loading-dot"></span>
          </div>
      </div>)}
    {isShow && <MyProvider>
      <AppContext.Provider value={appContextValue}>
        <SnackBar />
        <Routes>
          <Route path="/404" element={<Error />} />
          <Route path="/address-encoding" element={<AddressEncoding />} />
          <Route path="/" element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Home />} />
          </Route>
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </AppContext.Provider>
    </MyProvider>}
      <AlertModal />
  </>);
}

export default App;
